import { toPng } from 'html-to-image';
import { exportApi } from '../api/export';
import types from '../types';

export const exportFile = (format, exportItems, jwt) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.EXPORT_PENDING });
    const data = await exportApi(format, exportItems, jwt);

    if (data.data) {
      // trigger download of the file
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = data.data.shareToken;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      dispatch({ type: types.reducerTypes.EXPORT_SUCCESS });
    }
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.EXPORT_ERROR, payload: 'Unexpected Error!' });
  }
};

export const exportFileToPng = (exportItems) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.EXPORT_PNG_PENDING });
    const item = exportItems[0];
    const chart = document.getElementById(`chart-${item.contextId}`);
    if (!chart) throw new Error('Question chart no exists.');
    const dataUrl = await toPng(chart, {
      quality: 0.95,
      backgroundColor: '#ffffff',
    });

    const link = document.createElement('a');
    link.download = `question-${item.contextId}.png`;
    link.href = dataUrl;
    link.click();
    dispatch({ type: types.reducerTypes.EXPORT_PNG_SUCCESS });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.EXPORT_PNG_ERROR, payload: 'Unexpected Error!' });
  }
};
